import React, { Component } from "react";
import styles from "./ContactForm.module.scss";

export class ContactForm extends Component {
  state = {
    from_name: "",
    reply_to: "",
    message_html: "",
    _confirmation: "",
    formErrors: {
      from_name: true,
      reply_to: true,
      message_html: true
    },
    isSubmited: false
  };

  handleChange = ({ target: { value, name } }) => {
    this.setState(() => ({
      [name]: value
    }));
  };
  clearState = () => {
    this.setState(() => ({
      from_name: "",
      reply_to: "",
      message_html: "",
      _confirmation: "",
      formErrors: {
        from_name: "",
        reply_to: "",
        message_html: ""
      }
    }));
  };
  checkForm = () => {
    const { from_name, reply_to, message_html, _confirmation } = this.state;
    let formErrors = { ...this.state.formErrors };
    if (_confirmation !== "") return false;
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    formErrors.reply_to = re.test(String(reply_to).toLowerCase())
      ? true
      : false;
    formErrors.from_name = from_name.length < 1 ? false : true;
    formErrors.message_html = message_html.length < 10 ? false : true;
    this.setState(() => ({
      formErrors: formErrors
    }));
    return Object.values(formErrors).some(error => (error ? false : true));
  };

  handleSubmit = e => {
    e.preventDefault();
    const { from_name, reply_to, message_html, formErrors } = this.state;
    if (this.checkForm(formErrors)) return;
    const params = {
      user_id: "user_6TTXl04Vr6RgwEsQWdovC",
      service_id: "default_service",
      template_id: "template_GHFVjqkm",
      template_params: {
        from_name: from_name,
        reply_to: reply_to,
        message_html: message_html
      }
    };
    const headers = {
      "Content-type": "application/json"
    };

    const options = {
      method: "POST",
      headers: headers,
      body: JSON.stringify(params)
    };
    fetch("https://api.emailjs.com/api/v1.0/email/send", options)
      .then(httpResponse => {
        if (httpResponse.ok) {
          this.clearState();
          this.setState(state => {
            return { isSubmited: true };
          });
        } else {
          this.setState(state => {
            return { isSubmited: false };
          });
          return httpResponse.text().then(text => Promise.reject(text));
        }
      })
      .catch(error => {
        console.log("Oops... " + error);
      });
  };
  render() {
    const { from_name, reply_to, message_html } = this.state.formErrors,
      { isSubmited } = this.state;
    return (
      <div className={styles.container}>
        <h2 className={styles.container__title}>Contact me:</h2>
        {isSubmited ? (
          <div>
            <p className={styles.form__label}>
              Your message has been sent successfully.
              <br />
              Thank you!
            </p>
          </div>
        ) : (
          <form
            className={styles.form}
            method="POST"
            id="form"
            onSubmit={this.handleSubmit}
            noValidate
          >
            <label>
              <p className={styles.form__label}>Name</p>
              <input
                className={styles.form__input}
                type="text"
                name="from_name"
                value={this.state.value}
                onChange={this.handleChange}
                required
              />
            </label>

            {!from_name && (
              <span className={styles.error}>Please, enter your name!</span>
            )}
            <label>
              <p className={styles.form__label}>Email</p>
              <input
                className={styles.form__input}
                type="email"
                name="reply_to"
                required
                value={this.state.value}
                onChange={this.handleChange}
              />
            </label>
            {!reply_to && (
              <span className={styles.error}>
                Please, enter your email correctly!
              </span>
            )}
            <label>
              <p className={styles.form__label}>Message</p>
              <textarea
                className={styles.form__textarea}
                name="message_html"
                rows="8"
                value={this.state.value}
                onChange={this.handleChange}
                required
              />
            </label>
            {!message_html && (
              <span className={styles.error}>Minimum 20 characters ;)</span>
            )}
            <input
              type="hidden"
              name="_confirmation"
              value={this.state.value}
              onChange={this.handleChange}
            />
            <button id="submit" className={styles.form__submit} type="submit">
              Send
            </button>
          </form>
        )}
      </div>
    );
  }
}

export default ContactForm;
